import React from 'react';
import { TeacherOrientation2026 } from '../views';

const SchoolProgrampage = () => {
  return <TeacherOrientation2026 />;
};

export default SchoolProgrampage;